module.exports = __webpack_public_path__ + "static/img/cstSer_bg_white_06.6544e853.svg";